import firebase from 'firebase/app';
import 'firebase/auth';
import { firebase_config } from "@/config/config";

if (!firebase.apps.length) {
    firebase.initializeApp(firebase_config);
}
export const app: firebase.app.App = firebase.app();
export const auth: firebase.auth.Auth = firebase.auth();
export const provider_google: firebase.auth.GoogleAuthProvider = new firebase.auth.GoogleAuthProvider();
export const provider_facebook: firebase.auth.FacebookAuthProvider = new firebase.auth.FacebookAuthProvider();